module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/logos/logo-grad-4e1fc399d059fe4fb5972e78981eea70.svg";